//@flow

export type ProductOption = {
  optionId: string,
  optionGroupId: string,
};

export function buildCartItemID(
  productId: string,
  productVariantId?: string,
  productOptions?: ProductOption[]
) {
  let itemId = productId;
  if (productVariantId) itemId += `-${productVariantId}`;
  if (productOptions) {
    itemId += `-${productOptions
      .map(option => [option.optionGroupId, option.optionId].join('-'))
      .join('-')}`;
  }

  return itemId;
}
